// extracted by mini-css-extract-plugin
module.exports = {"productItem":"styles_productItem__3EPtZ","picture":"styles_picture__3nHqp","info":"styles_info__2wPBo","price":"styles_price__1ubZU","actions":"styles_actions__32GRo"};